module.exports = __webpack_public_path__ + "static/index/img/baikal-305.29e00c6b.jpg";